var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-container"},[_c('div',{staticClass:"centered-content"},[_c('v-progress-circular',{attrs:{"size":"100","indeterminate":"","color":"gray"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }